import { shouldPolyfill } from '@formatjs/intl-segmenter/should-polyfill'
import { getBadActorFlagKey, setBadActorData } from './badActorStore'

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/im
const emojiRegEx = /\p{Emoji_Presentation}/imu
const numberRegEx = /\d{3}/im

/**
 * Checks a string for sanitized characters such as email addresses, punctuation, and phone numbers.
 * Updates bad actor data if any sanitized characters are found.
 *
 * @param {string} string - The string to check for sanitized characters.
 * @returns {Promise<boolean>} - Returns true if unauthorized characters exist, otherwise false.
 * @throws {Error} - Throws an error if the argument is not a string.
 */
export default async function checkForSanitizedCharacters(string) {
  if (typeof string !== 'string') {
    throw new Error('Argument must be a string')
  }
  const key = 'checkForSanitizedCharacters'
  if (shouldPolyfill()) {
    await import('@formatjs/intl-segmenter/polyfill-force')
  }
  const keyData = await getBadActorFlagKey(key)
  const segmenter = new Intl.Segmenter()

  const internationalizedString = Array.from(segmenter.segment(string, { granularity: 'grapheme' }))
    .map((segment) => segment.segment)
    .join('')

  const checkObj = {
    includesEmailAddress: emailRegex.test(internationalizedString),
    includesPhoneNumber: numberRegEx.test(internationalizedString),
    includesEmoji: emojiRegEx.test(internationalizedString),
  }

  if (keyData?.enabled) {
    const failures = Object.keys(checkObj).filter((ky) => checkObj[ky])
    const data = {}
    // console.log(`failures`, failures)
    data.pass = failures.length === 0
    data.editedTerm = string

    setBadActorData(key, data)
    return failures.length > 0
  }
  return false
}
